import { CrudsList } from 'constants/crudsList/CrudsData'

export function getAbmUrl(cod_abm: string) {
	const abmUrl = CrudsList.find((abm) => {
		return abm.urlApi === cod_abm
	})

	return abmUrl?.dataUrl
}
